import React from 'react';
import PropTypes from 'prop-types';

import {Card, CardActions, Stack, Box, Typography, IconButton, FiveStar} from 'views/components';

import {DeleteOutline as DeleteIcon} from 'views/icons';

import {Translate} from 'views/module';

import moment from 'moment';

const ReviewCard = (props) => {
  const {
    review,
    setReviewToDelete,
    isShowingConfirmDeleteDialog,
    setIsShowingConfirmDeleteDialog,
  } = props;

  const formatDate = (dateString) => {
    return moment(dateString).format('MMM YYYY');
  };

  return (
    <Card variant="outlined" sx={{width: '100%', p: 2}}>
      <Stack direction="row" justifyContent="space-between" alignContent="flex-start">
        <Stack spacing={1}>
          <Stack alignItems="flex-start">
            <Stack direction="row" spacing={1}>
              <Typography variant="h6" sx={{fontWeight: 600}}>
                {review.reviewerName}
              </Typography>
              <Box
                sx={{
                  border: 2,
                  borderColor: 'grey.300',
                  borderRadius: 2,
                  display: 'inline-block',
                  width: 'fit-content',
                  px: 1,
                  py: 0.5,
                }}
              >
                <Typography variant="subtitle2" fontWeight="bold">
                  {review.relationship}
                </Typography>
              </Box>
            </Stack>
            <Typography variant="body2" color="text.secondary">
              {formatDate(review.date)}
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" spacing={1} sx= {{py: 1}}>
            <FiveStar name="read-only" value={review.rating} precision={0.5} readOnly
              sx={{color: 'primary.main'}}
            />
            <Typography variant="body2" sx={{fontWeight: 500}}>
              {review.rating.toFixed(1)}
            </Typography>
            {
              review.isVerified &&
              <Box
                sx={{
                  backgroundColor: '#effdf4',
                  color: '#148655',
                  px: 1.25,
                  py: 0.25,
                  borderRadius: 2,
                  borderWidth: 2,
                  borderStyle: 'solid',
                  borderColor: '#d1f9df',
                  fontSize: '0.75rem',
                  fontWeight: 500,
                  display: 'inline-block',
                  width: 'auto',
                }}
              >
                <Translate expression="caregiver.CaregiverReview.Verified" />
              </Box>
            }
          </Stack>
          <Typography variant="body2" color="text.secondary">
            {review.text}
          </Typography>
        </Stack>
        <CardActions sx={{alignSelf: 'flex-start'}}>
          <IconButton
            variant="outlined"
            onClick={() => {
              setReviewToDelete(review.caregiverReviewRn);
              setIsShowingConfirmDeleteDialog(true);
            }}
            disabled={isShowingConfirmDeleteDialog}
            sx={{
              'color': 'secondary.main',
              '&:hover': {
                color: 'secondary.dark',
              },
            }}>
            <DeleteIcon/>
          </IconButton>
        </CardActions>
      </Stack>
    </Card>
  );
};

ReviewCard.propTypes = {
  isShowingConfirmDeleteDialog: PropTypes.bool.isRequired,
  setIsShowingConfirmDeleteDialog: PropTypes.func.isRequired,
  setReviewToDelete: PropTypes.func.isRequired,
  review: PropTypes.shape({
    caregiverReviewRn: PropTypes.string.isRequired,
    reviewerName: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    isVerified: PropTypes.bool.isRequired,
    relationship: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};

export default React.memo(ReviewCard);
